import { lazy } from 'react';

import { ProfilePageRouteBase } from '@/App/AppRoutes/ProfilePageRouteBase';
import type { AppRouteConfig } from '@/App/AppRoutes/types';

const ProfilePage = lazy(() =>
  import('@/components/pages/ProfilePage/ProfilePageWrapper').then(({ ProfilePageWrapper }) => ({
    default: ProfilePageWrapper,
  })),
);

export const ProfilePageRoute: AppRouteConfig = {
  ...ProfilePageRouteBase,
  component: ProfilePage,
};
